<template>
  <div>
    <v-flex xs12 sm6 offset-sm3 md6 offset-md3>
      <v-card>
        <v-img v-if="imageUrlIsAvailable" :src="imageUrl"></v-img>
      </v-card>
    </v-flex>

    <v-flex xs11 offset-xs1 sm5 offset-sm4 md5 offset-md4>
      <v-card style="padding: 2px">

        <v-layout row wrap style="padding: 10px">
          <v-flex xs10 sm9 md10 lg10 xl11></v-flex>
          <v-flex style="padding: 10px">
            <a :href="imageUrl" class="linkicon"><v-icon>cloud_download</v-icon></a>
          </v-flex>
          <!-- <v-flex xs2 sm3 md2 lg2 xl1>
            <v-avatar color="red">
              <span class="white--text headline">b</span>
            </v-avatar>
          </v-flex> -->
          <v-flex xs10 sm9 md10 lg10 xl11 style="padding: 10px">
            <div class="subheading">{{ this.posts[this.postId].caption }}</div>
            <div class="grey--text">{{ getUserName() }} {{ formatDate() }}</div>
          </v-flex>
        </v-layout>

        <div v-for="(comment, index) in allComments" :key="index">
          <v-layout row wrap style="padding: 10px">
            <v-flex xs10 sm9 md10 lg10 xl11 style="padding: 10px">
              <div class="subheading">{{ comment.caption }}</div>
              <div class="grey--text">{{ getUserName(comment.user) }} {{ formatDate(comment.created)  }}</div>
            </v-flex>
          </v-layout>
        </div>

        <v-layout row wrap style="padding: 10px">
          <v-flex xs10>
            <v-text-field label="Add a comment..." v-model="newComment"></v-text-field>
          </v-flex>
          <v-flex xs2>
            <v-btn fab dark small color="grey" @click="saveComment">+</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
import Moment from 'moment'
import {mapState, mapActions} from 'vuex'

const fb = require('../firebase')

export default {
  name: 'Post',
  props: ['postData'],
  data () {
    return {
      imageUrlIsAvailable: false,
      imageUrl: '',
      newComment: '',
      allComments: []
    }
  },
  computed: {
    ...mapState(['posts', 'users', 'comments']),
    postId: function () {
      return this.postData.id
    } /*,
    allComments: function () {
      return Object.values(this.comments)
    } */
  },
  watch: {
    comments: function () {
      this.populateComments()
    }
  },
  mounted () {
    let user = fb.auth.currentUser
    if (!user) {
      this.$router.push({path: '/login'})
    }

    this.getImage()
    this.populateComments()
  },
  methods: {
    ...mapActions(['addComment']),
    populateComments: function () {
      this.allComments = []

      let postComments = Object.values(this.posts[this.postId].comments)

      postComments.forEach((commentRef) => {
        let commentToAdd = this.comments[commentRef.id]
        // console.log('commentToAdd', commentToAdd)
        if (commentToAdd !== undefined) {
          this.allComments.push(commentToAdd)
        }
      })
    },
    getUserName: function (ref) {
      let output = ''
      if (ref === undefined) {
        let userId = this.posts[this.postId].user.id
        if (userId !== undefined) {
          let userName = this.users[userId]
          if (userName !== undefined) {
            output = userName.name
          }
        }
      } else {
        let userName = this.users[ref.id]
        if (userName !== undefined) {
          output = userName.name
        }
      }
      return output
    },
    formatDate: function (t) {
      if (t === undefined) {
        return Moment.unix(this.posts[this.postId].created.seconds).fromNow()
      } else {
        return Moment.unix(t.seconds).fromNow()
      }
    },
    getImage: function () {
      let that = this
      fb.storage.ref(this.posts[this.postId].asset)
        .getDownloadURL()
        .then(function (url) {
          that.imageUrl = url
          that.imageUrlIsAvailable = true
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    saveComment: function () {
      if (this.newComment !== '') {
        this.addComment([this.newComment, this.postId])
        this.newComment = ''
      }
    }
  }
}
</script>

<style scoped>
.linkicon {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Post.vue